import {
  DatePickerController,
  GroupCodesController,
  HtmlEditorController,
  NominalIdsController,
  TextFieldController,
} from '@/components/controls';
import { isNotTooBig } from '@/utils';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import { startOfDay } from 'date-fns';
import { Fragment, useEffect } from 'react';
import { useForm } from 'react-hook-form';

export function NoticeEditorDialog({
  notice,
  isOpen,
  onClose,
  onDelete,
  isDeleting,
}) {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: notice,
  });

  useEffect(() => {
    reset(notice);
  }, [reset, notice, isOpen]);

  function handleClose() {
    onClose();
  }

  return (
    <form id="notice-editor-form" onSubmit={handleSubmit(onClose)}>
      <Dialog
        open={isOpen && !!notice}
        onClose={handleClose}
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle>{`${notice.code ? 'Edit' : 'Add'} Notice`}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText gutterBottom>
              Notices are for safety/information/logistical matters. Crime or
              intelligence information should be added elsewhere in the brief
              such as in Priority Intelligence.
            </DialogContentText>
            <DialogContentText>
              Please fill in the form below to add a notice. If groups are not
              specified then the notice will be visible to all.
            </DialogContentText>
            <GroupCodesController
              label="Groups"
              control={control}
              name="groupCodes"
              types={['SECTOR', 'TEAM']}
            />
            <TextFieldController
              name="title"
              label="Title"
              control={control}
              rules={{ required: 'Required' }}
            />
            <DatePickerController
              name="expiryDate"
              label="Expiry Date"
              control={control}
              rules={{ required: 'Required' }}
              minDate={startOfDay(new Date())}
            />
            <HtmlEditorController
              name="contentHTML"
              placeholder="Write something..."
              control={control}
              rules={{ required: 'Required', validate: isNotTooBig }}
            />
            <NominalIdsController
              control={control}
              name="nominalIds"
              label="Nominal IDs"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          {!!notice.code && (
            <Fragment>
              <Button color="error" onClick={onDelete} disabled={isDeleting}>
                Delete
              </Button>
              <Box sx={{ flexGrow: 1 }} />
            </Fragment>
          )}
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            form="notice-editor-form"
            type="submit"
            disabled={isSubmitting}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
